export default "__VITE_ASSET__DeJvjJ4p__"